const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function trim(s) {
  return (s === null || s === undefined ? "" : String(s)).trim();
}

/**
 * @returns {string|null} Single message if invalid; null if step can proceed.
 */
export function validatePublicWizardStep(step, form, rows) {
  if (step === 0) {
    if (!trim(form.customerName)) return "Please enter your name.";
    if (!trim(form.email)) return "Please enter your email.";
    if (!EMAIL_RE.test(trim(form.email))) return "Please enter a valid email address.";
    return null;
  }
  if (step === 1) {
    if (!trim(form.originAddress1)) return "Please enter your origin address (line 1).";
    if (!trim(form.originCity)) return "Please enter the origin city.";
    if (!trim(form.originState)) return "Please enter the origin state.";
    if (!trim(form.originPincode)) return "Please enter the origin PIN code.";
    return null;
  }
  if (step === 2) {
    if (!trim(form.destinationAddress1)) return "Please enter your destination address (line 1).";
    if (!trim(form.destinationCity)) return "Please enter the destination city.";
    if (!trim(form.destinationState)) return "Please enter the destination state.";
    if (!trim(form.destinationPincode)) return "Please enter the destination PIN code.";
    return null;
  }
  if (step === 3) {
    const validLines = (rows || []).filter((r) => {
      const nm = trim(r.item);
      const qty = Number(r.quantity);
      return nm && Number.isFinite(qty) && qty > 0;
    });
    if (!validLines.length) {
      return "Add at least one item with a name and quantity greater than zero.";
    }
    return null;
  }
  return null;
}
